<div class="notice-wrapper yellow">
  <hyperkit-typography
    variant="body"
    size="md"
    color="secondary"
    class="notice-text"
  >
    <i class="k-icon k-font-icon k-i-info"></i>
    <ng-content></ng-content>
  </hyperkit-typography>
</div>
